// Translation: Account > Billing > Statistics (Turkish)
export default Object.freeze({
	cards: {
		endOfThisMonth: {
			fields: {
				balance: 'Bakiye',
				expenses: 'Masraflar',
				revenue: 'Gelir'
			},
			title: 'Bu ayın sonu (Tahmini)'
		},
		lastMonth:{
			fields: {
				balance: 'Bakiye',
				expenses: 'Masraflar',
				revenue: 'Gelir'
			},
			title: 'Geçen ay'
		},
		monthToDate: {
			fields: {
				balance: 'Bakiye',
				expenses: 'Masraflar',
				revenue: 'Gelir'
			},
			title: 'Ayından başından beri'
		}
	},
	fallback: {
		unavailable: 'Bilgi mevcut değil.'
	},
	title: 'Kullanım istatistikleri'
})
